import { useState } from "react";
import LeftSidebar from "./LeftSidebar";
import RightSidebar from "./RightSidebar";

export default function MobileBottomSidebar() {
  const [activeTab, setActiveTab] = useState("ranking");

  return (
    <div className="lg:hidden mt-4">
      <div className="flex border-b border-background-300 mb-3">
        <button
          onClick={() => setActiveTab("ranking")}
          className={`flex-1 py-2.5 text-xs font-medium text-center whitespace-nowrap transition-colors ${
            activeTab === "ranking"
              ? "text-primary-400 border-b-2 border-primary-500"
              : "text-foreground-500 hover:text-foreground-300"
          }`}
        >
          <i className="ri-trophy-line mr-1" />
          리그순위 / 랭킹
        </button>
        <button
          onClick={() => setActiveTab("login")}
          className={`flex-1 py-2.5 text-xs font-medium text-center whitespace-nowrap transition-colors ${
            activeTab === "login"
              ? "text-primary-400 border-b-2 border-primary-500"
              : "text-foreground-500 hover:text-foreground-300"
          }`}
        >
          <i className="ri-user-line mr-1" />
          로그인 / 인기검색 / 공지
        </button>
      </div>
      <div className="max-h-[60vh] overflow-y-auto pr-1">
        <div className="flex flex-col gap-3">
          {activeTab === "ranking" ? <LeftSidebar /> : <RightSidebar />}
        </div>
      </div>
    </div>
  );
}